/* Set up using Vue 2 */
import Vue from "vue";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

// /* import font awesome icon component */
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";

/* add icons to the library */
library.add(faTwitter, faUserSecret);

/* add font awesome icon component */
// Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;
